module.exports = "/_next/static/images/cafe_haleiwa_apperance-038ad10236460f786f1808e56c957ad9.jpg";